<template>
    <van-overlay :show="showed" v-bind="$attrs" :z-index="4000">
        <div class="congratulation">
            <div class="title">{{ $t('congratulations') }}</div>
            <div :class="['content', { active: showActive }]">
                <template v-if="type === 1">
                    <div v-if="(msg as any)?.gifts?.gold || (msg as any)?.worth?.gold" class="item cash">
                        <div class="pic">
                            <img src="@/assets/img/dialog/congratulations/cash.png" />
                        </div>
                        <div class="text">
                            Cash <span>{{ store.cureencySymbol() }}{{ ((msg as any)?.gifts?.gold || 0) + (msg as any)?.worth?.gold }}</span>
                        </div>
                    </div>
                    <div v-if="(msg as any)?.gifts?.bonus" class="item bonus">
                        <div class="pic">
                            <img src="@/assets/img/dialog/bonus/bouns.png" />
                        </div>
                        <div class="text">
                            Bonus <span>{{ (msg as any)?.gifts?.bonus || 0 }}</span>
                        </div>
                    </div>
                </template>

                <!-- 自定义类型 -->
                <template v-if="type === 2">
                    <div v-for="(item, index) in typeData" :key="index + item.id" class="item">
                        <div class="pic">
                            <img class="pic" :src="item?.img" />
                        </div>
                        <div class="text">
                            {{ item.name }}
                            <span
                                ><span v-if="!item.hideSymbol && item.id !== 'bonus'">{{ store.cureencySymbol() }}</span
                                >{{ item.worth }}</span
                            >
                        </div>
                    </div>
                </template>

                <!-- 优惠券类型 -->
                <template v-if="type === 3">
                    <div class="item coupon">
                        <div class="pic">
                            <img :src="(msg as MsgType3)?.img" />
                        </div>
                        <div class="text" v-if="(msg as MsgType3)?.discountRate">
                            <span>{{ $t('coupon_off_name', { number: ((msg as MsgType3)?.discountRate || 0) * 100 }) }}</span>
                        </div>
                    </div>
                </template>

                <!-- 救济金膨胀类型 -->
                <template v-if="type === 4">
                    <div class="item relief-boost" :class="{ 'ratio-shrink': reliefAnimationPhase === 2 }">
                        <div class="pic">
                            <img src="@/assets/img/relief/pig-cash.png" />
                        </div>
                        <div class="text">
                            <div class="boost-ratio" :class="{ animating: reliefAnimationPhase === 1 }">
                                <span class="mr-[10px] text-[32px] !text-[#fff] font-[400]">{{ $t('relief_fund_title') }}</span>
                                <span v-if="(msg as MsgType4)?.ratio !== 1"
                                    >{{ store.cureencySymbol() + (msg as MsgType4)?.basegold }}x{{ animatedRatio }}</span
                                >
                                <span v-else>{{ store.cureencySymbol() + (msg as MsgType4)?.basegold }}</span>
                            </div>
                            <div class="boost-tip" v-show="reliefAnimationPhase >= 2">
                                {{ $t('relief_fund_notif4') }}
                            </div>
                        </div>
                    </div>
                </template>
                <!-- cdk -->
                <template v-if="type === 5">
                    <div class="item">
                        <div class="pic">
                            <img src="@/assets/img/dialog/congratulations/code.avif" />
                        </div>
                        <div class="text">{{ $t('wed_redeemcode') }} {{ msg }}</div>
                    </div>
                </template>
            </div>

            <!-- 优惠券折扣提示 -->
            <div v-if="couponDiscountAmount" class="coupon-discount-text" v-html="$t('popup_coupon_notif', { value: couponDiscountAmount })" />
            <div v-if="type === 5" class="btn" @click="copyCode">{{ $t('Confirm') }}</div>
            <div v-else class="btn" @click="handleConfirm">{{ confirmButtonText }}</div>
        </div>
    </van-overlay>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import popupManager from '@/utils/PopupManager'
import eventBus from '@/utils/bus'
import { useI18n } from 'vue-i18n'
// import { useClipboard1 } from '@/hooks/useCopy'

const emit = defineEmits(['complete'])
// 定义类型接口
interface MsgType1 {
    gifts?: {
        gold?: number
        bonus?: number
    }
    worth?: {
        gold?: number
    }
    couponData?: {
        discountRate: number
        useError?: string
    }
    cny?: number
    originalCny?: number
}

interface MsgType2Item {
    id: string
    img?: string
    name?: string
    worth?: number
    hideSymbol?: boolean
}

// 彩票类型
interface MsgType3 {
    id?: string
    img?: string
    name?: string
    discountRate?: number
    validDays?: number
}

// 救济金膨胀类型
interface MsgType4 {
    basegold: number
    ratio: number
    awardgold: number
}

type MsgType = MsgType1 | MsgType2Item[] | MsgType3 | MsgType4 | string

const props = withDefaults(
    defineProps<{
        type?: number
        msg?: MsgType
        animated?: boolean
        check?: boolean
        forceShow?: boolean
    }>(),
    {
        type: 0,
        check: true,
        animated: true,
        forceShow: false,
    }
)
// const { toClipboard } = useClipboard1()
const showed = defineModel<boolean>('show')
const store = useBaseStore()
const { t } = useI18n()

// 救济金动画状态：0-初始，1-系数动画中，2-动画完成缩小
const reliefAnimationPhase = ref(0)
const animatedRatio = ref(1)

const showActive = computed(() => {
    if (props.type === 1) {
        const { bonus, gold } = (props.msg as MsgType1)?.gifts || {}
        return props.type === 1 && bonus && gold
    }
    return false
})
const typeData = computed(() => {
    return props.type === 2 && !Array.isArray(props.msg) ? [props.msg as MsgType2Item] : (props.msg as MsgType2Item[]) || []
})
// 计算打折金额
const couponDiscountAmount = computed(() => {
    if (props.type === 1) {
        const { cny, originalCny, couponData } = (props.msg as MsgType1) || {}
        if (!couponData || couponData.useError) return 0
        if ((originalCny || 0) > (cny || 0)) {
            return store.cureencySymbol() + (originalCny - cny)
        }
        return 0
    }
    return 0
})

// 确认按钮文本
const confirmButtonText = computed(() => {
    if (props.type === 4 && reliefAnimationPhase.value >= 2) {
        const awardgold = (props.msg as MsgType4)?.awardgold || 0
        return `${t('Claim')} ${store.cureencySymbol()}${awardgold}`
    }
    return t('Confirm')
})

// 救济金系数动画
const startReliefAnimation = () => {
    if (props.type !== 4) return

    const targetRatio = (props.msg as MsgType4)?.ratio || 1

    // 如果ratio为1，直接进入最终状态，不播放动画
    if (targetRatio === 1) {
        reliefAnimationPhase.value = 2
        animatedRatio.value = 1
        return
    }

    reliefAnimationPhase.value = 1
    animatedRatio.value = 1

    // 系数动画：从1到目标ratio，持续2秒
    const duration = 2000
    const startTime = Date.now()
    const startRatio = 1

    const animate = () => {
        const elapsed = Date.now() - startTime
        const progress = Math.min(elapsed / duration, 1)

        // 使用缓动函数让动画更自然
        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        animatedRatio.value = Number((startRatio + (targetRatio - startRatio) * easeOutQuart).toFixed(1))

        if (progress < 1) {
            requestAnimationFrame(animate)
        } else {
            // 动画完成后等待0.5秒再缩小
            setTimeout(() => {
                reliefAnimationPhase.value = 2
            }, 500)
        }
    }

    requestAnimationFrame(animate)
}

// 监听弹窗显示状态，开始动画
watch(
    showed,
    (newVal, oldVal) => {
        console.log('showed changed:', { newVal, oldVal, type: props.type })
        // 只有当弹窗从false变为true，且类型为4时才开始动画
        if (newVal && !oldVal && props.type === 4) {
            console.log('Starting relief animation...')
            // 重置动画状态
            reliefAnimationPhase.value = 0
            animatedRatio.value = 1
            // 延迟启动动画，确保弹窗完全显示
            setTimeout(startReliefAnimation, 300)
        }
    },
    { immediate: false }
)

// 备选方案：组件挂载时如果弹窗已经显示且是救济金类型，则启动动画
onMounted(() => {
    console.log(234567890, props)
    if (props.forceShow) {
        showed.value = true
    }
    if (showed.value && props.type === 4) {
        // 重置动画状态
        reliefAnimationPhase.value = 0
        animatedRatio.value = 1
        // 延迟启动动画，确保弹窗完全显示
        setTimeout(startReliefAnimation, 500)
    }
})

const handleConfirm = () => {
    if (props.type === 2) {
        if (typeData.value.some((item) => item.id === 'bonus')) {
            eventBus.emit('bloomAnimate', 2)
        }
        if (props.animated && typeData.value.some((item) => Object.keys(store.gameList?.items || {}).includes(item.id))) {
            eventBus.emit('bloomAnimate', {
                type: 1,
                img: typeData.value[0]?.img,
            })
        }
    }
    showed.value = false
    emit('complete')
    if (props.check || props.forceShow) {
        popupManager.checkQueue()
    }
}
const copyCode = () => {
    // toClipboard(props.msg)
    showed.value = false
}

// onMounted(() => {
//     showed.value = true
// })
</script>
<style lang="scss" scoped>
.congratulation {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 718px;
    transform: translate3d(-50%, -50%, 0);
    font-family: 'Microsoft YaHei';
    text-align: center;

    .title {
        line-height: 60px;
        font-size: 72px;
        font-weight: 700;
        color: #fff;
    }
    .content {
        @apply flex justify-center items-center;
        height: 500px;

        .item {
            @apply flex flex-col items-center;
            position: relative;
            width: 525px;
            min-height: 518px;
            padding-top: 140px;

            &::before {
                position: absolute;
                top: 0;
                left: 50%;
                width: 525px;
                height: 518px;
                content: '';
                margin-left: -262.5px;
                background: url('@/assets/img/dialog/welcome-gift/sun.png') no-repeat;
                background-size: 100% 100%;
                z-index: -1;
                animation: rotate 2.5s linear infinite;
            }
            .text {
                padding-top: 80px;
            }
            .pic {
                @apply flex justify-center items-start;
                width: 200px;
                height: 200px;

                img {
                    width: 100%;
                }
            }

            &.tiket {
                .text {
                    padding-top: 40px;
                }
            }
            .text {
                font-size: 32px;
                font-weight: 400;
                color: #fff;
                span {
                    color: #fff050;
                }
            }
        }
        &.active {
            height: 450px;
            .item {
                width: 310px;
                min-height: 318px;
                padding-top: 70px;
                &::before {
                    top: -40px;
                    width: 378px;
                    height: 372px;
                    margin-left: -189px;
                }
            }
            .pic {
                width: 190px;
                height: 190px;
            }
            .bonus {
                .pic {
                    img {
                        width: 160px;
                        height: 160px;
                    }
                }
            }
            .text {
                padding-top: 30px;
            }
        }
    }
    .btn {
        @apply flex justify-center items-center;
        margin: 0 auto;
        width: 589px;
        height: 96px;
        font-size: 44px;
        font-weight: 400;
        color: #fff;
        border-radius: 100px;
        background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
        box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset;
    }
}
@keyframes rotate {
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg);
    }
}
</style>
